import { Component, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Image as MediaImage } from '../../models/image';

@Component({
  selector: 'app-fullscreen-image-viewer',
  templateUrl: './fullscreen-image-viewer.component.html',
  styleUrls: ['./fullscreen-image-viewer.component.css']
})
export class FullscreenImageViewerComponent {
  currentIndex: number;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { images: Array<string | MediaImage>, index: number },
    private dialogRef: MatDialogRef<FullscreenImageViewerComponent>
  ) {
    this.currentIndex = data.index;
  }

  next() {
    if (this.currentIndex < this.data.images.length - 1) this.currentIndex++;
  }
  prev() {
    if (this.currentIndex > 0) this.currentIndex--;
  }
  close() {
    this.dialogRef.close();
  }

  trackByIndex(i: number) { return i; }

  get currentImageUrl(): string {
    const item = this.data.images[this.currentIndex];
    if (typeof item === 'string') return item;
    return item?.firebaseUrl || '';
  }

  @HostListener('window:keydown', ['$event'])
  handleKey(event: KeyboardEvent) {
    if (event.key === 'ArrowRight') this.next();
    if (event.key === 'ArrowLeft') this.prev();
    if (event.key === 'Escape') this.close();
  }
}
